<template>
  <!-- Custom tabs (Charts with tabs)-->
  <div class="card" v-if="false">
    <div class="card-header d-md-flex p-3 mt-4 align-items-center">
      <div class="form-group">
        <multiselect
          :options="reportsOptions"
          v-model="reports"
          placeholder="Select Status"
          @select="selectReport"
          :searchable="true"
          :show-labels="false"
          :allow-empty="false"
          :hide-selected="true"
          label="name"
          track-by="value"
        ></multiselect>
      </div>
      <template v-if="reports.value==='total'">
        <h6 class="px-3">Segmented by</h6>
        <div class="form-group">
          <multiselect
            :options="segmentOptions"
            v-model="segment"
            placeholder="Select Status"
            @select="selectReport"
            :searchable="true"
            :show-labels="false"
            :allow-empty="false"
            :hide-selected="true"
          ></multiselect>
        </div>
      </template>
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="tab-content p-0">
        <!-- Morris chart - Sales -->
        <div  style="position: relative;">

    <!-- :chartdata="getReports.data"
            :chartlabels="getReports.labels" -->
         
          <component
            :is="'top-country-chart'"
            :height="200"
            style="height: auto;"
            :chartdata="todos.data"
            :chartlabels="todos.labels"
          />
        </div>

      </div>
    </div>
    <!-- /.card-body -->
  </div>
  <!-- /.card -->
</template>

<script>
import BarChart from "./BarChart.vue";
import Icon from "@/assets/Icon.svg";

import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
export default {
  components: {
    "top-country-chart": BarChart,
    Multiselect,
  },

  props: {

    title: {
      type: String,
      required: true,
    },
  },


  computed:{
  ...mapState({
    chart_reports: state => state.dashboard.chart_reports
  }),

  getReports(){

    return this.chart_reports || {}


  }
},

  

  mounted() {

      let segment = null;
      let report = this.reports.value;
        if (report === "total") {
          segment = this.segment;
      }
     // console.log({ report, segment });
      this.$emit('selectReport', {report, segment})
  },

  methods: {
    selectReport(val) {

      let segment = null;
      let report = null;

      if (typeof val === 'object') {
        report = val.value;

        if (report === "total") {
          segment = this.segment;
        }
      } else {
        report = this.reports.value;
        segment = val;
      }

      //console.log({ report, segment });
      this.$emit('selectReport', {report, segment})
    },
  },

  data() {
    return {
      Icon,
      loaded: true,
      reports: { name: "Total Listeners", value: "total" },
      reportsOptions: [
        { name: "Total Listeners", value: "total" },
        { name: "Unique Listeners", value: "unique" },
        { name: "Peak Listeners", value: "peak" },
        { name: "Average Listening Time", value: "avgTime" },
      ],

      segment: "Country",
      segmentOptions: ["Country", "Platform", "Client"],

        todos: {
        labels: [
          "1:00AM",
          "3:00AM",
          "5:00AM",
          "7:00AM",
          "9:00AM",
          "11:00AM",
          "1:00PM",
          "3:00PM",
          "7:00PM",
          "9:00PM",
        ],
        data: [10, 5, 20, 120, 230],
      },
    };
  },
};
</script>